module.exports = __webpack_public_path__ + "852dd60c8696e4412b34393e5d7f20eb.png";